import React from 'react';
import AdvisoryProps from '../interfaces/AdvisoryProps';

const AdvisoryComposer: React.FC<AdvisoryProps> = ({ packageName, advisory }) => {

    return (
        <div>
            <h4>{packageName}</h4>
            <ul>
                <li>Title : {advisory.title}</li>
                <li>CVE : {advisory.cve}</li>
                <li>Severity : {advisory.severity}</li>
                <li>Affected Versions : {advisory.affectedVersions}</li>
                <li>Link : <a href={advisory.link} target="_blank" rel="noreferrer">{advisory.link}</a></li>
            </ul>
        </div>
    );
}

export default AdvisoryComposer;